var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRemovecross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.765,
    height: 36.765,
    viewBox: "0 0 36.765 36.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_9056866_close_icon",
    "data-name": "9056866_close_icon",
    d: "M8.439,5.191A2.3,2.3,0,0,0,5.191,8.439L18.453,21.7,5.191,34.963a2.3,2.3,0,0,0,3.248,3.248L21.7,24.949,34.963,38.211a2.3,2.3,0,0,0,3.248-3.248L24.949,21.7,38.211,8.439a2.3,2.3,0,0,0-3.248-3.248L21.7,18.453Z",
    transform: "translate(-3.318 -3.318)",
    fill: "#00824f",
    stroke: "#000",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovecross);
export default __webpack_public_path__ + "static/media/removecross.188c4e9462f654dba6ebbbac0357ec70.svg";
export { ForwardRef as ReactComponent };